const clamp = (value, minimum, maximum) =>
  Math.min(Math.max(value, minimum), Math.max(minimum, maximum))

export const floatingListboxPosition = (
  anchor,
  boundary,
  contentHeight,
  { gap = 4, margin = 8, maxHeight = 240, preferredHeight = 144 } = {}
) => {
  const boundaryLeft = boundary.left + margin
  const boundaryRight = boundary.right - margin
  const boundaryTop = boundary.top + margin
  const boundaryBottom = boundary.bottom - margin
  const availableBelow = Math.max(0, boundaryBottom - anchor.bottom - gap)
  const availableAbove = Math.max(0, anchor.top - boundaryTop - gap)
  const desiredHeight = Math.min(Math.max(0, contentHeight), maxHeight)
  const opensBelow =
    availableBelow >= Math.min(desiredHeight, preferredHeight) ||
    availableBelow >= availableAbove
  const availableHeight = opensBelow ? availableBelow : availableAbove
  const renderedHeight = Math.min(desiredHeight, availableHeight)
  const boundaryWidth = Math.max(0, boundaryRight - boundaryLeft)
  const width = Math.min(Math.max(0, anchor.width), boundaryWidth)
  const viewportLeft = clamp(anchor.left, boundaryLeft, boundaryRight - width)
  const viewportTop = opensBelow
    ? anchor.bottom + gap
    : Math.max(boundaryTop, anchor.top - gap - renderedHeight)

  return {
    placement: opensBelow ? "bottom" : "top",
    left: viewportLeft - boundary.left,
    top: viewportTop - boundary.top,
    width,
    maxHeight: availableHeight,
  }
}
